import React from 'react';
import { ClipboardListIcon, ClockIcon, FolderOpenIcon, ScissorsIcon } from 'lucide-react';
import { Accent, SectionHeading } from './SectionHeading';
import { painPoints } from '../../data/content';
const icons = [ClockIcon, FolderOpenIcon, ScissorsIcon, ClipboardListIcon];
export function PainSection() {
  return <section aria-labelledby="pain-heading" className="bg-brand-oatmeal px-5 py-16 lg:px-8 lg:py-24" data-id="element-144" data-mp="3m1p7phg0674e">
      <div className="mx-auto max-w-5xl" data-id="element-145" data-mp="nhp0md43g90w">
        <SectionHeading id="pain-heading" eyebrow="Vous reconnaissez-vous ?" title={<>
              Vous aimez enseigner le barbering… <Accent data-id="element-147" data-mp="drmbio03ff7u">mais préparer chaque cours vous prend un temps fou ?</Accent>
            </>} body="Vous maîtrisez les techniques de coupe, mais entre la préparation des leçons, la recherche de supports visuels, la création d’exercices et l’évaluation des élèves, vos journées deviennent vite interminables." data-id="element-146" data-mp="nkuoxq4wf6vk" />

        <ul className="mt-12 grid gap-4 sm:grid-cols-2" role="list" data-id="element-148" data-mp="3bd9fk1go4zq2">
          {painPoints.map((pain, index) => {
          const Icon = icons[index];
          return <li key={pain.title} className="flex items-start gap-4 rounded-[20px] bg-brand-ivory p-6" data-id="element-149" data-mp="3gef3zn3aq0ts" data-mpi={index}>
                <span className="flex h-11 w-11 flex-none items-center justify-center rounded-full bg-white" data-id="element-150" data-mp="31llpo4zrfqqp">
                  <Icon className="h-5 w-5 text-brand-gold" strokeWidth={1.5} aria-hidden="true" data-id="element-151" data-mp="2smrn7xzr0658" />
                </span>
                <span data-id="element-152" data-mp="2wov2yytg9wwb">
                  <span className="block font-display text-[1.35rem] font-bold leading-tight text-brand-charcoal" data-id="element-153" data-mp="2wp4sklal221h">
                    {pain.title}
                  </span>
                  <span className="mt-1.5 block text-[14px] leading-relaxed text-brand-charcoal/65" data-id="element-154" data-mp="2nn59lng0cnvw">{pain.text}</span>
                </span>
              </li>;
        })}
        </ul>

        <p className="mx-auto mt-12 max-w-2xl text-center font-display text-[1.6rem] font-bold leading-snug text-brand-charcoal sm:text-[1.9rem]" data-id="element-155" data-mp="lwtuk8zpt71m">
          Et si vous disposiez enfin <Accent data-id="element-156" data-mp="kcs9eidylfjf">d’une bibliothèque pédagogique structurée</Accent> pour vous accompagner ?
        </p>
      </div>
    </section>;
}